import { Component, DestroyRef, effect, inject, signal } from '@angular/core';
import { FormField, disabled, form } from '@angular/forms/signals';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthFacade } from '@app/store/auth';
import { BackButtonService } from '@app/core/libraries';
import { FormPinComponent, PIN_LENGTH } from '@shared/forms';

// The lock screen is a login screen: it drives the PIN login directly through AuthFacade.
// The device store observes the outcome (login success while locked) to resolve the gate.
@Component({
    selector: 'app-lock',
    templateUrl: './lock.component.html',
    styleUrls: ['./lock.component.css'],

    imports: [TranslatePipe, FormField, FormPinComponent],
})
export class LockComponent {
    private readonly authFacade = inject(AuthFacade);

    private readonly model = signal({ pin: '' });
    // A complete PIN is a submitted PIN: the keypad locks while it's in flight and unlocks
    // when the error effect below clears the model.
    protected readonly pinForm = form(this.model, (path) => {
        disabled(path.pin, { when: ({ value }) => value().length === PIN_LENGTH });
    });

    constructor() {
        const swallowBack = inject(BackButtonService).register(() => undefined);
        inject(DestroyRef).onDestroy(swallowBack);

        effect(() => {
            const pin = this.model().pin;
            if (pin.length === PIN_LENGTH) {
                this.authFacade.loginWithPin(pin);
            }
        });

        // A failed re-auth surfaces as a toast (AuthEffects); reset the field so the user can
        // retry. `!== null`: a network-level failure arrives as code 0, which is falsy.
        effect(() => {
            if (this.authFacade.error() !== null) {
                this.model.set({ pin: '' });
            }
        });
    }
}
